// extracted by mini-css-extract-plugin
export default {"window":"Frame_window__lFH6E","container":"Frame_container__McyOl","wrapper":"Frame_wrapper__O-hOn","page":"Frame_page__jEwXK","page--active":"Frame_page--active__VSthh"};